import { normalizeToMonthly } from '../../../context/FinancialContext';

export const fmt = (value) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
}).format(value || 0);

export const FREQ_ABBR = { weekly: 'wk', biweekly: '2wk', monthly: 'mo', yearly: 'yr' };
const DISCRETIONARY_ACCOUNTS = ['discretionary', 'spouse_freedom', 'vacation'];
export const isDiscretionary = (item) => DISCRETIONARY_ACCOUNTS.includes(item.accountType);
export const sumMonthly = (list) => list.reduce((total, item) => total + normalizeToMonthly(item.amount, item.frequency || 'monthly'), 0);
export const futureValue = (monthly, annualRoi, years) => {
  const rate = (annualRoi || 0) / 100 / 12;
  const months = Math.max(0, years) * 12;
  if (monthly <= 0 || months === 0) return 0;
  if (rate === 0) return monthly * months;
  return monthly * ((Math.pow(1 + rate, months) - 1) / rate);
};
export const getEmergencyBase = (shared, required = 0) => shared.emergencyExpenses ?? (required > 0 ? Math.round(required) : 2000);
export const getRetireSpending = (shared, monthlyExpenses) => shared.retireSpending ?? (monthlyExpenses > 0 ? Math.round(monthlyExpenses) : 5000);